<template>
  <datepicker
    :placeholder="trans('general.ddMMyyyy')"
    v-model="date"
    format="dd.MM.yyyy"
    :language="translations"
    :monday-first="true"
    :disabled-dates="disabledDateRange"
    @input="$emit('removeerror')"
  ></datepicker>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { ru, uk } from "vuejs-datepicker/dist/locale";

export default {
  mixins: [],
  components: {
    Datepicker,
  },
  props: {
    value: {
      required: true,
    },
    datesTimes: {
      // type: Object,
      required: true,
    },
    default: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      date: this.value,
    };
  },
  created() {},
  beforeMount() {},
  mounted() {},
  watch: {
    value(newValue) {
      if (newValue == null) {
        this.date = newValue;
      }
    },
    date(newVal) {
      if (newVal) {
        this.$emit("input", this.formatDate(newVal));
      }
    },
  },
  computed: {
    dates() {
      return Object.keys(this.datesTimes);
    },
    disabledDateRange() {
      if (this.default) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return { to: today };
      } else {
        return {
          customPredictor: (date) => {
            const allowedDates = this.dates;
            const day = date.getDate().toString().padStart(2, "0"); // ведущий ноль, если день однозначный
            const month = (date.getMonth() + 1).toString().padStart(2, "0"); // ведущий ноль, если месяц однозначный
            const formattedDate = day + "." + month + "." + date.getFullYear();

            if (allowedDates.includes(formattedDate)) {
              return false;
            }
            return true;
          },
        };
      }
    },
    translations() {
      return window.globalVariables.lang == "ua" ? uk : ru;
    },
  },
  methods: {
    formatDate(originalDate) {
      const dateObj = new Date(originalDate);
      const day = dateObj.getDate().toString().padStart(2, "0");
      const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
      const year = dateObj.getFullYear();
      return `${day}.${month}.${year}`;
    },
  },
};
</script>
